export const iconFontAwesomeShapesHeart = (
	<i className="fa-solid fa-heart"></i>
);
